// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Admin User Activity — Dark Theme ===== */

/* Header */
.admin-activity__header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.admin-activity__back-btn {
  width: 36px;
  height: 36px;
  border: 1px solid var(--admin-border);
  background: var(--admin-surface);
  border-radius: var(--radius-md);
  cursor: pointer;
  color: var(--admin-text-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  flex-shrink: 0;
}

.admin-activity__back-btn:hover {
  background: var(--admin-surface-hover);
  color: var(--admin-text-bright);
  border-color: var(--admin-text-dim);
}

.admin-activity__user-name {
  color: var(--admin-text-primary);
  font-weight: 600;
}

.admin-activity__user-sep {
  color: var(--admin-text-muted);
}

.admin-activity__user-email {
  color: var(--admin-text-muted);
}

.admin-activity__user-role {
  margin-left: 8px;
}

/* Tabs */
.admin-activity__tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.admin-activity__tab {
  padding: 10px 18px;
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  font-size: 13px;
  font-weight: 500;
  color: var(--admin-text-secondary);
  background: var(--admin-surface);
  cursor: pointer;
  transition: all 0.2s;
}

.admin-activity__tab:hover {
  background: var(--admin-surface-hover);
  color: var(--admin-text-primary);
}

.admin-activity__tab--active {
  background: var(--admin-surface-hover);
  color: var(--admin-text-bright);
  border-color: #a78bfa;
}

/* Master-Detail Layout */
.admin-activity__layout {
  display: flex;
  gap: 16px;
  height: calc(100vh - 220px);
  min-height: 480px;
}

.admin-activity__list-pane {
  width: 360px;
  min-width: 320px;
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-lg);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.admin-activity__detail-pane {
  flex: 1 1;
  min-width: 0;
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-lg);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.admin-activity__list-header {
  padding: 12px 16px;
  border-bottom: 1px solid var(--admin-border);
  display: flex;
  align-items: center;
  gap: 8px;
}

.admin-activity__list-header .admin-user__search-input {
  width: 100%;
}

.admin-activity__list-title {
  font-size: 13px;
  font-weight: 600;
  color: var(--admin-text-secondary);
}

.admin-activity__list-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 8px;
}

.admin-activity__list-card {
  display: block;
  width: 100%;
  text-align: left;
  padding: 12px 14px;
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  background: transparent;
  color: var(--admin-text-primary);
  cursor: pointer;
  transition: all 0.15s;
  margin-bottom: 4px;
}

.admin-activity__list-card:hover {
  background: var(--admin-surface-hover);
}

.admin-activity__list-card--active {
  background: rgba(167, 139, 250, 0.12);
  border-color: #a78bfa;
}

.admin-activity__list-card-title {
  font-size: 13px;
  font-weight: 500;
  color: var(--admin-text-bright);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-bottom: 6px;
  line-height: 1.4;
  word-break: break-word;
}

.admin-activity__list-card-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 11px;
  color: var(--admin-text-muted);
  align-items: center;
}

.admin-activity__model-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: var(--radius-full);
  font-size: 10px;
  font-weight: 600;
  background: rgba(167, 139, 250, 0.12);
  color: #a78bfa;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.admin-activity__status {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: var(--radius-full);
  font-size: 10px;
  font-weight: 600;
  background: var(--admin-surface-hover);
  color: var(--admin-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.admin-activity__status--completed,
.admin-activity__status--success,
.admin-activity__status--done {
  background: var(--admin-success-bg);
  color: var(--admin-success);
}

.admin-activity__status--running,
.admin-activity__status--active,
.admin-activity__status--in_progress {
  background: var(--admin-info-bg);
  color: var(--admin-info);
}

.admin-activity__status--failed,
.admin-activity__status--error,
.admin-activity__status--cancelled {
  background: var(--admin-error-bg);
  color: var(--admin-error);
}

.admin-activity__empty {
  padding: 40px 16px;
  text-align: center;
  font-size: 13px;
  color: var(--admin-text-muted);
}

/* Pagination */
.admin-activity__pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 10px 16px;
  border-top: 1px solid var(--admin-border);
}

.admin-activity__pagination-info {
  font-size: 12px;
  color: var(--admin-text-secondary);
  font-variant-numeric: tabular-nums;
}

/* Detail header */
.admin-activity__detail-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid var(--admin-border);
}

.admin-activity__detail-back {
  display: none;
  width: 32px;
  height: 32px;
  border: 1px solid var(--admin-border);
  background: var(--admin-bg);
  border-radius: var(--radius-md);
  cursor: pointer;
  color: var(--admin-text-secondary);
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  flex-shrink: 0;
}

.admin-activity__detail-back:hover {
  background: var(--admin-surface-hover);
  color: var(--admin-text-bright);
}

.admin-activity__detail-meta {
  flex: 1 1;
  min-width: 0;
}

.admin-activity__detail-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--admin-text-bright);
  margin-bottom: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
}

.admin-activity__detail-sub {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  font-size: 12px;
  color: var(--admin-text-muted);
  align-items: center;
}

.admin-activity__detail-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
  flex-wrap: wrap;
}

.admin-activity__detail-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.admin-activity__detail-empty {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px;
  color: var(--admin-text-muted);
  font-size: 13px;
  gap: 12px;
}

.admin-activity__detail-empty-icon {
  width: 48px;
  height: 48px;
  stroke: currentColor;
  fill: none;
  color: var(--admin-text-dim);
}

.admin-activity__detail-empty-title {
  font-size: 14px;
  font-weight: 500;
  color: var(--admin-text-secondary);
}

/* Messages */
.admin-activity__msg {
  padding: 12px 14px;
  border-radius: var(--radius-md);
  background: var(--admin-bg);
  border: 1px solid var(--admin-border);
}

.admin-activity__msg--user {
  background: rgba(34, 211, 238, 0.05);
  border-color: rgba(34, 211, 238, 0.2);
}

.admin-activity__msg--assistant {
  background: rgba(167, 139, 250, 0.06);
  border-color: rgba(167, 139, 250, 0.22);
}

.admin-activity__msg--system {
  background: var(--admin-bg);
  border-color: var(--admin-border);
  opacity: 0.9;
}

.admin-activity__msg-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 6px;
  font-size: 11px;
  color: var(--admin-text-muted);
}

.admin-activity__msg-role {
  font-weight: 700;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--admin-text-secondary);
}

.admin-activity__msg--user .admin-activity__msg-role {
  color: var(--admin-info);
}

.admin-activity__msg--assistant .admin-activity__msg-role {
  color: #a78bfa;
}

.admin-activity__msg-time {
  font-size: 11px;
  color: var(--admin-text-muted);
  white-space: nowrap;
}

.admin-activity__msg-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.admin-activity__msg-latency {
  font-size: 11px;
  color: var(--admin-text-muted);
  font-variant-numeric: tabular-nums;
}

.admin-activity__msg-images {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.admin-activity__msg-image {
  max-width: 240px;
  max-height: 240px;
  border-radius: var(--radius-md);
  border: 1px solid var(--admin-border);
  object-fit: cover;
}

.admin-activity__msg-body {
  font-size: 13px;
  color: var(--admin-text-primary);
  line-height: 1.6;
  word-break: break-word;
}

.admin-activity__msg-body > :first-child { margin-top: 0; }
.admin-activity__msg-body > :last-child { margin-bottom: 0; }

.admin-activity__msg-body p {
  margin: 8px 0;
}

.admin-activity__msg-body code {
  background: var(--admin-surface-hover);
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 12px;
  font-family: 'SF Mono', Monaco, Menlo, Consolas, monospace;
}

.admin-activity__msg-body pre {
  background: var(--admin-surface-hover);
  padding: 12px;
  border-radius: var(--radius-md);
  overflow-x: auto;
  font-size: 12px;
  line-height: 1.5;
}

.admin-activity__msg-body pre code {
  background: transparent;
  padding: 0;
}

.admin-activity__msg-body table {
  width: 100%;
  border-collapse: collapse;
  margin: 8px 0;
  font-size: 12px;
}

.admin-activity__msg-body th,
.admin-activity__msg-body td {
  border: 1px solid var(--admin-border);
  padding: 6px 10px;
  text-align: left;
}

.admin-activity__msg-body img {
  max-width: 100%;
  border-radius: var(--radius-md);
}

.admin-activity__msg-body a {
  color: var(--admin-info);
  text-decoration: underline;
}

.admin-activity__msg-body ul,
.admin-activity__msg-body ol {
  padding-left: 20px;
  margin: 8px 0;
}

.admin-activity__msg-body blockquote {
  margin: 8px 0;
  padding: 4px 12px;
  border-left: 3px solid var(--admin-text-dim);
  color: var(--admin-text-secondary);
}

/* Tool Calls */
.admin-activity__msg-tools {
  margin-top: 8px;
  border-top: 1px dashed var(--admin-border);
  padding-top: 8px;
}

.admin-activity__msg-tools-title {
  font-size: 11px;
  font-weight: 600;
  color: var(--admin-text-muted);
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.admin-activity__msg-tools-body {
  margin: 0;
  padding: 8px 10px;
  background: var(--admin-surface-hover);
  border-radius: var(--radius-md);
  font-size: 11px;
  color: var(--admin-text-secondary);
  max-height: 240px;
  overflow: auto;
  line-height: 1.4;
  font-family: 'SF Mono', Monaco, Menlo, Consolas, monospace;
  white-space: pre-wrap;
  word-break: break-all;
}

.admin-activity__msg-tools-count {
  color: var(--admin-text-muted);
  font-weight: 500;
}

.admin-activity__tool-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 6px;
}

.admin-activity__tool-item {
  padding: 6px 10px;
  background: var(--admin-surface-hover);
  border-left: 2px solid var(--admin-accent);
  border-radius: var(--radius-md);
}

.admin-activity__tool-head {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.admin-activity__tool-slug {
  font-family: 'SF Mono', Monaco, Menlo, Consolas, monospace;
  font-size: 12px;
  font-weight: 600;
  color: var(--admin-text-primary);
}

.admin-activity__tool-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 11px;
  font-weight: 600;
}

.admin-activity__tool-badge svg {
  flex-shrink: 0;
}

.admin-activity__tool-badge--success {
  color: var(--admin-success);
}

.admin-activity__tool-badge--error {
  color: var(--admin-error);
}

.admin-activity__tool-badge--unknown {
  color: var(--admin-text-muted);
}

.admin-activity__tool-ms {
  font-size: 11px;
  color: var(--admin-text-muted);
}

.admin-activity__tool-preview {
  margin-top: 4px;
}

.admin-activity__tool-preview > summary {
  cursor: pointer;
  font-size: 11px;
  color: var(--admin-text-secondary);
  -webkit-user-select: none;
          user-select: none;
}

.admin-activity__tool-preview > summary:hover {
  color: var(--admin-text-primary);
}

.admin-activity__tool-preview pre {
  margin: 4px 0 0;
  padding: 6px 8px;
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-sm);
  font-family: 'SF Mono', Monaco, Menlo, Consolas, monospace;
  font-size: 11px;
  color: var(--admin-text-secondary);
  line-height: 1.4;
  white-space: pre-wrap;
  word-break: break-all;
  max-height: 200px;
  overflow: auto;
}

/* Activity button in user management row */
.admin-user__activity-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  background: transparent;
  color: var(--admin-text-muted);
  cursor: pointer;
  transition: all 0.2s;
  margin-right: 4px;
}

.admin-user__activity-btn:hover {
  background: rgba(167, 139, 250, 0.12);
  border-color: #a78bfa;
  color: #a78bfa;
}

`, "",{"version":3,"sources":["webpack://./src/css/AdminUserActivity.css"],"names":[],"mappings":"AAAA,iDAAiD;;AAEjD,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,gCAAgC;EAChC,+BAA+B;EAC/B,eAAe;EACf,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,gCAAgC;EAChC,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,+BAA+B;EAC/B,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,kCAAkC;EAClC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;;;EAGE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;;;EAGE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,8BAA8B;AAChC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,2BAA2B;EAC3B,+BAA+B;EAC/B,eAAe;EACf,kCAAkC;EAClC,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,2CAA2C,aAAa,EAAE;AAC1D,0CAA0C,gBAAgB,EAAE;;AAE5D;EACE,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,4CAA4C;EAC5C,kCAAkC;AACpC;;AAEA,eAAe;AACf;EACE,eAAe;EACf,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,sCAAsC;EACtC,+BAA+B;EAC/B,eAAe;EACf,kCAAkC;EAClC,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,0DAA0D;EAC1D,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,0DAA0D;EAC1D,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kCAAkC;EAClC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,0DAA0D;EAC1D,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,+BAA+B;EAC/B,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,cAAc;AAChB","sourcesContent":["/* ===== Admin User Activity — Dark Theme ===== */\n\n/* Header */\n.admin-activity__header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.admin-activity__back-btn {\n  width: 36px;\n  height: 36px;\n  border: 1px solid var(--admin-border);\n  background: var(--admin-surface);\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  color: var(--admin-text-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n  flex-shrink: 0;\n}\n\n.admin-activity__back-btn:hover {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-bright);\n  border-color: var(--admin-text-dim);\n}\n\n.admin-activity__user-name {\n  color: var(--admin-text-primary);\n  font-weight: 600;\n}\n\n.admin-activity__user-sep {\n  color: var(--admin-text-muted);\n}\n\n.admin-activity__user-email {\n  color: var(--admin-text-muted);\n}\n\n.admin-activity__user-role {\n  margin-left: 8px;\n}\n\n/* Tabs */\n.admin-activity__tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n\n.admin-activity__tab {\n  padding: 10px 18px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--admin-text-secondary);\n  background: var(--admin-surface);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.admin-activity__tab:hover {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-primary);\n}\n\n.admin-activity__tab--active {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-bright);\n  border-color: #a78bfa;\n}\n\n/* Master-Detail Layout */\n.admin-activity__layout {\n  display: flex;\n  gap: 16px;\n  height: calc(100vh - 220px);\n  min-height: 480px;\n}\n\n.admin-activity__list-pane {\n  width: 360px;\n  min-width: 320px;\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-lg);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.admin-activity__detail-pane {\n  flex: 1;\n  min-width: 0;\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-lg);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.admin-activity__list-header {\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--admin-border);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.admin-activity__list-header .admin-user__search-input {\n  width: 100%;\n}\n\n.admin-activity__list-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--admin-text-secondary);\n}\n\n.admin-activity__list-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 8px;\n}\n\n.admin-activity__list-card {\n  display: block;\n  width: 100%;\n  text-align: left;\n  padding: 12px 14px;\n  border: 1px solid transparent;\n  border-radius: var(--radius-md);\n  background: transparent;\n  color: var(--admin-text-primary);\n  cursor: pointer;\n  transition: all 0.15s;\n  margin-bottom: 4px;\n}\n\n.admin-activity__list-card:hover {\n  background: var(--admin-surface-hover);\n}\n\n.admin-activity__list-card--active {\n  background: rgba(167, 139, 250, 0.12);\n  border-color: #a78bfa;\n}\n\n.admin-activity__list-card-title {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--admin-text-bright);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  margin-bottom: 6px;\n  line-height: 1.4;\n  word-break: break-word;\n}\n\n.admin-activity__list-card-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  font-size: 11px;\n  color: var(--admin-text-muted);\n  align-items: center;\n}\n\n.admin-activity__model-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: var(--radius-full);\n  font-size: 10px;\n  font-weight: 600;\n  background: rgba(167, 139, 250, 0.12);\n  color: #a78bfa;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.admin-activity__status {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: var(--radius-full);\n  font-size: 10px;\n  font-weight: 600;\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.admin-activity__status--completed,\n.admin-activity__status--success,\n.admin-activity__status--done {\n  background: var(--admin-success-bg);\n  color: var(--admin-success);\n}\n\n.admin-activity__status--running,\n.admin-activity__status--active,\n.admin-activity__status--in_progress {\n  background: var(--admin-info-bg);\n  color: var(--admin-info);\n}\n\n.admin-activity__status--failed,\n.admin-activity__status--error,\n.admin-activity__status--cancelled {\n  background: var(--admin-error-bg);\n  color: var(--admin-error);\n}\n\n.admin-activity__empty {\n  padding: 40px 16px;\n  text-align: center;\n  font-size: 13px;\n  color: var(--admin-text-muted);\n}\n\n/* Pagination */\n.admin-activity__pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 10px 16px;\n  border-top: 1px solid var(--admin-border);\n}\n\n.admin-activity__pagination-info {\n  font-size: 12px;\n  color: var(--admin-text-secondary);\n  font-variant-numeric: tabular-nums;\n}\n\n/* Detail header */\n.admin-activity__detail-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--admin-border);\n}\n\n.admin-activity__detail-back {\n  display: none;\n  width: 32px;\n  height: 32px;\n  border: 1px solid var(--admin-border);\n  background: var(--admin-bg);\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  color: var(--admin-text-secondary);\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n  flex-shrink: 0;\n}\n\n.admin-activity__detail-back:hover {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-bright);\n}\n\n.admin-activity__detail-meta {\n  flex: 1;\n  min-width: 0;\n}\n\n.admin-activity__detail-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--admin-text-bright);\n  margin-bottom: 6px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  word-break: break-word;\n}\n\n.admin-activity__detail-sub {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  font-size: 12px;\n  color: var(--admin-text-muted);\n  align-items: center;\n}\n\n.admin-activity__detail-actions {\n  display: flex;\n  gap: 8px;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n}\n\n.admin-activity__detail-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.admin-activity__detail-empty {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 40px;\n  color: var(--admin-text-muted);\n  font-size: 13px;\n  gap: 12px;\n}\n\n.admin-activity__detail-empty-icon {\n  width: 48px;\n  height: 48px;\n  stroke: currentColor;\n  fill: none;\n  color: var(--admin-text-dim);\n}\n\n.admin-activity__detail-empty-title {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--admin-text-secondary);\n}\n\n/* Messages */\n.admin-activity__msg {\n  padding: 12px 14px;\n  border-radius: var(--radius-md);\n  background: var(--admin-bg);\n  border: 1px solid var(--admin-border);\n}\n\n.admin-activity__msg--user {\n  background: rgba(34, 211, 238, 0.05);\n  border-color: rgba(34, 211, 238, 0.2);\n}\n\n.admin-activity__msg--assistant {\n  background: rgba(167, 139, 250, 0.06);\n  border-color: rgba(167, 139, 250, 0.22);\n}\n\n.admin-activity__msg--system {\n  background: var(--admin-bg);\n  border-color: var(--admin-border);\n  opacity: 0.9;\n}\n\n.admin-activity__msg-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 6px;\n  font-size: 11px;\n  color: var(--admin-text-muted);\n}\n\n.admin-activity__msg-role {\n  font-weight: 700;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: var(--admin-text-secondary);\n}\n\n.admin-activity__msg--user .admin-activity__msg-role {\n  color: var(--admin-info);\n}\n\n.admin-activity__msg--assistant .admin-activity__msg-role {\n  color: #a78bfa;\n}\n\n.admin-activity__msg-time {\n  font-size: 11px;\n  color: var(--admin-text-muted);\n  white-space: nowrap;\n}\n\n.admin-activity__msg-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.admin-activity__msg-latency {\n  font-size: 11px;\n  color: var(--admin-text-muted);\n  font-variant-numeric: tabular-nums;\n}\n\n.admin-activity__msg-images {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.admin-activity__msg-image {\n  max-width: 240px;\n  max-height: 240px;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--admin-border);\n  object-fit: cover;\n}\n\n.admin-activity__msg-body {\n  font-size: 13px;\n  color: var(--admin-text-primary);\n  line-height: 1.6;\n  word-break: break-word;\n}\n\n.admin-activity__msg-body > :first-child { margin-top: 0; }\n.admin-activity__msg-body > :last-child { margin-bottom: 0; }\n\n.admin-activity__msg-body p {\n  margin: 8px 0;\n}\n\n.admin-activity__msg-body code {\n  background: var(--admin-surface-hover);\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-size: 12px;\n  font-family: 'SF Mono', Monaco, Menlo, Consolas, monospace;\n}\n\n.admin-activity__msg-body pre {\n  background: var(--admin-surface-hover);\n  padding: 12px;\n  border-radius: var(--radius-md);\n  overflow-x: auto;\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n.admin-activity__msg-body pre code {\n  background: transparent;\n  padding: 0;\n}\n\n.admin-activity__msg-body table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 8px 0;\n  font-size: 12px;\n}\n\n.admin-activity__msg-body th,\n.admin-activity__msg-body td {\n  border: 1px solid var(--admin-border);\n  padding: 6px 10px;\n  text-align: left;\n}\n\n.admin-activity__msg-body img {\n  max-width: 100%;\n  border-radius: var(--radius-md);\n}\n\n.admin-activity__msg-body a {\n  color: var(--admin-info);\n  text-decoration: underline;\n}\n\n.admin-activity__msg-body ul,\n.admin-activity__msg-body ol {\n  padding-left: 20px;\n  margin: 8px 0;\n}\n\n.admin-activity__msg-body blockquote {\n  margin: 8px 0;\n  padding: 4px 12px;\n  border-left: 3px solid var(--admin-text-dim);\n  color: var(--admin-text-secondary);\n}\n\n/* Tool Calls */\n.admin-activity__msg-tools {\n  margin-top: 8px;\n  border-top: 1px dashed var(--admin-border);\n  padding-top: 8px;\n}\n\n.admin-activity__msg-tools-title {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--admin-text-muted);\n  margin-bottom: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.admin-activity__msg-tools-body {\n  margin: 0;\n  padding: 8px 10px;\n  background: var(--admin-surface-hover);\n  border-radius: var(--radius-md);\n  font-size: 11px;\n  color: var(--admin-text-secondary);\n  max-height: 240px;\n  overflow: auto;\n  line-height: 1.4;\n  font-family: 'SF Mono', Monaco, Menlo, Consolas, monospace;\n  white-space: pre-wrap;\n  word-break: break-all;\n}\n\n.admin-activity__msg-tools-count {\n  color: var(--admin-text-muted);\n  font-weight: 500;\n}\n\n.admin-activity__tool-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 6px;\n}\n\n.admin-activity__tool-item {\n  padding: 6px 10px;\n  background: var(--admin-surface-hover);\n  border-left: 2px solid var(--admin-accent);\n  border-radius: var(--radius-md);\n}\n\n.admin-activity__tool-head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.admin-activity__tool-slug {\n  font-family: 'SF Mono', Monaco, Menlo, Consolas, monospace;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--admin-text-primary);\n}\n\n.admin-activity__tool-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.admin-activity__tool-badge svg {\n  flex-shrink: 0;\n}\n\n.admin-activity__tool-badge--success {\n  color: var(--admin-success);\n}\n\n.admin-activity__tool-badge--error {\n  color: var(--admin-error);\n}\n\n.admin-activity__tool-badge--unknown {\n  color: var(--admin-text-muted);\n}\n\n.admin-activity__tool-ms {\n  font-size: 11px;\n  color: var(--admin-text-muted);\n}\n\n.admin-activity__tool-preview {\n  margin-top: 4px;\n}\n\n.admin-activity__tool-preview > summary {\n  cursor: pointer;\n  font-size: 11px;\n  color: var(--admin-text-secondary);\n  user-select: none;\n}\n\n.admin-activity__tool-preview > summary:hover {\n  color: var(--admin-text-primary);\n}\n\n.admin-activity__tool-preview pre {\n  margin: 4px 0 0;\n  padding: 6px 8px;\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-sm);\n  font-family: 'SF Mono', Monaco, Menlo, Consolas, monospace;\n  font-size: 11px;\n  color: var(--admin-text-secondary);\n  line-height: 1.4;\n  white-space: pre-wrap;\n  word-break: break-all;\n  max-height: 200px;\n  overflow: auto;\n}\n\n/* Activity button in user management row */\n.admin-user__activity-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  background: transparent;\n  color: var(--admin-text-muted);\n  cursor: pointer;\n  transition: all 0.2s;\n  margin-right: 4px;\n}\n\n.admin-user__activity-btn:hover {\n  background: rgba(167, 139, 250, 0.12);\n  border-color: #a78bfa;\n  color: #a78bfa;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
